export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Contenedor ", _interpolate(_named("container_code"))])},
          "container_tab_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen"])},
          "pallets_tab_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallets"])},
          "packages_tab_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "cross_tab_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor x Pallet"])},
          "sizes_by_pallet_tab_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calibres x Pallet"])}
        }
      }
    }
  })
}